import { ref } from 'vue';

export function useExpandableContent() {
  const contentRef = ref<HTMLElement | null>(null);
  const innerRef = ref<HTMLElement | null>(null);
  const isExpanded = ref(false);

  function onEnter(el: Element) {
    const htmlEl = el as HTMLElement;

    htmlEl.style.height = '0';
    htmlEl.style.overflow = 'hidden';

    // eslint-disable-next-line no-void
    void htmlEl.offsetHeight;

    const height = innerRef.value?.offsetHeight || 0;
    htmlEl.style.height = `${height}px`;
  }

  function onAfterEnter(el: Element) {
    const htmlEl = el as HTMLElement;

    htmlEl.style.height = '';
    htmlEl.style.overflow = '';
  }

  function onLeave(el: Element) {
    const htmlEl = el as HTMLElement;

    htmlEl.style.height = `${htmlEl.offsetHeight}px`;
    htmlEl.style.overflow = 'hidden';

    // eslint-disable-next-line no-void
    void htmlEl.offsetHeight;

    htmlEl.style.height = '0';
  }

  function toggleExpanded(e) {
    if (e) {
      e.stopPropagation();
    }

    isExpanded.value = !isExpanded.value;
  }

  return {
    contentRef,
    innerRef,
    isExpanded,
    onEnter,
    onAfterEnter,
    onLeave,
    toggleExpanded,
  };
}